import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { get, getOwner } from 'api/needsassessments';
import { getIdToken } from 'utils/okta';
import { matchRefreshPaths, getNotFoundPagePath, getFullPathOrHome } from 'utils/paths';
import { getNA } from 'api/externalAccess';
import actions from 'store/actions';
import paths from 'constants/paths';

export function useNaFetching() {
  const notfound = getNotFoundPagePath();
  const hasIdToken = Boolean(getIdToken());

  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const na = useSelector((state) => state.na);
  const [loading, setLoading] = useState(false);

  const getExternalNaById = async (id, apiToken, accessKey) => {
    setLoading(true);
    try {
      const na = await getNA(id, accessKey, apiToken);
      dispatch(actions.na.setNA(na));
      setLoading(false);
    } catch (e) {
      setLoading(false);
      history.push(getFullPathOrHome(paths.externalAccessDenied));
    }
  };

  const getNaById = async (id, apiToken) => {
    setLoading(true);
    try {
      const needsAssessment = await get(id, apiToken);
      dispatch(actions.na.setNA(needsAssessment));
      setLoading(false);
    } catch (error) {
      setLoading(false);
      switch (error.response.status) {
        case 404:
          history.push({
            pathname: notfound,
            state: {
              message: t('notFoundPage.notExistentError'),
            },
          });
          break;
        case 403:
          const owner = await getOwner(id);
          history.push({
            pathname: notfound,
            state: {
              message: t('notFoundPage.forbiddenAccessError', {
                email: owner.email?.toLowerCase(),
              }),
            },
          });
          break;
        default:
          history.push(notfound);
          break;
      }
    }
  };

  const fetchNa = (pathname) => {
    if (!hasIdToken || loading || pathname === notfound) return;

    const match = matchRefreshPaths(pathname);
    const newId = match && Number(match[3]);
    if (!newId || newId === na.id) return;

    getNaById(newId);
  };

  const fetchReportNa = (accessKey, id, apiToken) => {
    Boolean(accessKey) ? getExternalNaById(id, apiToken, accessKey) : getNaById(id, apiToken);
  };

  return [loading, { fetchNa, fetchReportNa }];
}
